// src/components/MainLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavigateFunction } from 'react-router-dom';
import Sidebar from '../Layouts/Dashboard/Sidebar';
import TopBar from '../Layouts/Dashboard/TopBar';

interface User {
  id: number;
  role: string;
}

interface MainLayoutProps {
  user: User | null;
  onNavigate: NavigateFunction;
  onLogout: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ user, onNavigate, onLogout }) => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>

      <Sidebar onNavigate={onNavigate} onLogout={onLogout} />

      <div style={{
        flex: 1,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#f9fafb',
        overflow: 'hidden',
      }}>
        <TopBar user={user} />

        <div style={{
          flex: 1,
          padding: '15px 20px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}>
          {/*
           * React Router renders the currently matched child route here.
           * MainLayout has zero knowledge of what those routes are — it just
           * provides the shell (sidebar + topbar + scroll area).
           */}
          <Outlet />
        </div>
      </div>

    </div>
  );
};

export default MainLayout;